module.exports = __webpack_public_path__ + "img/wxQRCode.01fe5977.webp";